var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex hours-heatmap overflow-x-auto"},_vm._l((_vm.dayHours),function(hour){return _c('div',{key:hour,staticClass:"d-flex w-100 justify-center align-center hours-heatmap__item",class:{
      'hours-heatmap__item--selected': _vm.isSelectableHour(hour),
      'hours-heatmap__item--has-data': _vm.hours.includes(hour),
      'hours-heatmap__item--highlighted': _vm.highlightedHours.includes(hour),
    },on:{"click":function($event){return _vm.selectHour(hour)}}},[_c('span',{staticClass:"caption"},[_vm._v("\n      "+_vm._s(`${hour}`.length > 1 ? hour : `0${hour}`)+"h\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }